var _rect, _rect2, _rect3, _line, _line2, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlockContactIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Block_32px",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1228",
    "data-name": "Rectangle 1228",
    width: 30,
    height: 30,
    transform: "translate(1 0.89)",
    fill: "#fff",
    opacity: 0
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_680",
    width: 32,
    height: 32,
    fill: "none"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_808",
    width: 30,
    height: 30,
    transform: "translate(1 0.88)",
    fill: "none"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line_117",
    "data-name": "Line 117",
    transform: "translate(7.89 4.35)",
    fill: "none",
    stroke: "#165cf3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.47
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "Line_118",
    "data-name": "Line 118",
    x2: 17.23,
    y2: 22.55,
    transform: "translate(7.43 4.69)",
    fill: "none",
    stroke: "#fc4c85",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_210",
    "data-name": "Ellipse 210",
    cx: 0.57,
    cy: 0.57,
    r: 0.57,
    transform: "translate(25.41 5.56)",
    fill: "#fd4e89"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1190",
    "data-name": "Path 1190",
    d: "M27.49,7.67a14.184,14.184,0,1,1-3.01-3.05",
    fill: "none",
    stroke: "#fe4e88",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.47
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockContactIcon);
export default __webpack_public_path__ + "static/media/block-contact-icon.bf7296916eb502c79a6fd67e71245f9d.svg";
export { ForwardRef as ReactComponent };